import React from 'react';
import { useNavigate } from 'react-router';
import { useSelector } from "react-redux";
import ModalWrapperChildren from '@/views/components/Modal/ModalWrapperChildren';
import api from "@/services/api";

const ModalDeleteQuestion = ({setShowModalDelete, showModalDelete, handleClose, id, getQuestions, setAlert}) => {
	const { dict } = useSelector(state => state.app);

	const navigate = useNavigate();

	const deleteQuestion = async () => {
		try {
			const data = await api.delete(`/questions/${id}`);
		
			if(data.status === 200) {
				if(getQuestions) {
					getQuestions();
					setAlert({content: dict.simpleTextAdvices.modalDelete.alert.deleted, variant: 'success'});
				} else {
					navigate('/simple-text-advices-admin');
				}
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		}
		
	};

	return (
		<ModalWrapperChildren
			onClose={ handleClose }
			setModalVisible={ setShowModalDelete }
			modalVisible={ showModalDelete }
			onConfirm={ deleteQuestion }
			closeButtonName={ dict.cancel }
			confirmButtonName={ dict.simpleTextAdvices.modalDelete.confirm }
			title={ dict.simpleTextAdvices.modalDelete.title }
			preTitle={ dict.simpleTextAdvices.modalDelete.preTitle }
			description={ dict.simpleTextAdvices.modalDelete.description }
		>
		</ModalWrapperChildren>
	);
};

export default ModalDeleteQuestion;